import { render, staticRenderFns } from "./abuse_category_selector.vue?vue&type=template&id=1a09fb70&vue3"
import script from "./abuse_category_selector.vue?vue&type=script&lang=js&vue3"
export * from "./abuse_category_selector.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports